import { Circle } from 'tabler-icons-react';
import { useDispatch, useSelector } from 'react-redux';

// import { useLocation } from 'react-router';
// import { parse } from 'query-string';
import { setSelectedFilter } from 'Actions';
import { FilterBox, CheckboxItem } from 'Elements';

export const FilterBoxStoryCategory = ({ onChange }) => {
	// const [param, setParam] = useQueryParam('category', StringParam);
	// const location = useLocation();
	// const params = decodeQueryParams(
	// 	{
	// 		category: StringParam
	// 	},
	// 	parse(location?.search)
	// 	);
		// console.log('param: ', param);
	const filters = useSelector((state) => state.fltr);
	const dispatch = useDispatch();
	const selectedFilter = filters.selected_filter;

	const handleFilterChange = (item, isChecked) => {
		let selected_cat = selectedFilter.categories;
		if (isChecked) {
			if (selected_cat.indexOf(item) === -1) {
				selected_cat.push(item);
			}
		} else {
			let index = selected_cat.indexOf(item);
			if (index > -1) {
				selected_cat.splice(index, 1);
			}
		}

		// setParam('hi');

		dispatch(
			setSelectedFilter({ name: 'categories', value: selected_cat })
		);
		onChange?.();
	};

	const checkSelctedCategory = (cat) => {
		return selectedFilter.categories?.includes(cat);
	};

	return (
		<FilterBox title="دسته بندی">
			{filters.categories?.map((cat, idx) => {
				return (
					<CheckboxItem
						key={idx}
						id={`checkbox-cat-${idx}`}
						label={cat}
						icon={Circle}
						item={cat}
						isChecked={checkSelctedCategory(cat)}
						onChange={handleFilterChange}
					/>
				);
			})}
		</FilterBox>
	);
};
